module.exports = __webpack_public_path__ + "files/fbaf75e480b7dc4a42fd3a6e306cbe98.svg";